(function () {
  'use strict';

  // ── Price formatter ──────────────────────────────────────────
  function formatMoney(cents) {
    const moneyFormat = window.Shopify && window.Shopify.money_format
      ? window.Shopify.money_format
      : (window.ShopifyConstant?.currentSymbol[window.Shopify?.currency?.active] || '') + '{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
  }

  // ── Escape HTML to prevent XSS ───────────────────────────────
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Fetch product via Liquid embed-data template (includes metafields) ──
  async function fetchProduct(handle) {
    // Primary: custom Liquid template returns price + sale_price server-side
    try {
      const res = await fetch('/products/' + handle + '?view=embed-data');
      if (!res.ok) throw new Error('embed-data ' + res.status);
      const data = await res.json();
      if (!data || !data.variants || !data.variants.length) throw new Error('no variants');
      return data;
    } catch (err) {
      console.warn('[inline-product-embed] embed-data failed, falling back to REST:', err);
    }

    // Fallback: REST API (no metafields, no discount)
    const res = await fetch('/products/' + handle + '.js');
    if (!res.ok) throw new Error('Product not found: ' + handle);
    const data = await res.json();
    return {
      title: data.title,
      handle: data.handle,
      featured_image: data.featured_image || (data.images && data.images[0]) || null,
      variants: data.variants.map(function (v) {
        return {
          id: v.id,
          price: v.price,
          compare_at_price: v.compare_at_price,
          available: v.available,
          metafieldCode: null
        };
      })
    };
  }

  // ── Build a single product card ──────────────────────────────
  function buildCard(product) {
    const variant   = product.variants.find(function (item) { return item.available; }) || product.variants[0];
    const image     = product.featured_image || null;
    const available = variant.available;

    // sale_price is pre-computed by Liquid template (in cents)
    const salePrice = (variant.sale_price != null && variant.sale_price > 0) ? variant.sale_price : null;

    let priceHtml;
    if (salePrice !== null) {
      priceHtml = `
        <span class="ip-card__price-current ip-card__price-current--sale">${formatMoney(salePrice)}</span>
        <s class="ip-card__price-compare">${formatMoney(variant.price)}</s>
      `;
    } else {
      // Fallback: compare_at_price
    const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price
      ? formatMoney(variant.compare_at_price)
      : null;
      priceHtml = `
      ${comparePrice ? `<s class="ip-card__price-compare">${comparePrice}</s>` : ''}
        <span class="ip-card__price-current${comparePrice ? ' ip-card__price-current--sale' : ''}">${formatMoney(variant.price)}</span>
    `;
    }

    const imageHtml = image
      ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" width="400" height="400">`
      : `<div class="ip-card__media-placeholder"></div>`;

    return `
      <div class="ip-card">
        <a href="/products/${product.handle}" class="ip-card__media-link" tabindex="-1" aria-hidden="true">
          <div class="ip-card__media">${imageHtml}</div>
        </a>
        <div class="ip-card__info">
          <div>
            <a href="/products/${product.handle}" class="ip-card__title">${escapeHtml(product.title)}</a>
            <div class="ip-card__price">${priceHtml}</div>
          </div>
          <button
            class="ip-card__btn"
            data-variant-id="${variant.id}"
            data-coupon="${escapeHtml(variant.metafieldCode || '')}"
            ${!available ? 'disabled' : ''}
            aria-label="Add ${escapeHtml(product.title)} to cart"
          >
            ${available ? 'Add To Cart' : 'Sold out'}
          </button>
        </div>
      </div>
    `;
  }

  // ── Apply discount code via Storefront API (mirrors lepro-common.js) ────
  async function applyDiscountCode(coupon) {
    if (!coupon) return;
    try {
      await window.ShopifyConstant.applyCartDiscountCodes([coupon]);
    } catch (err) {
      window.ShopifyConstant.reportCartDiscountError(err);
    }
  }

  function bindAddToCart(container) {
    container.querySelectorAll('.ip-card__btn[data-variant-id]:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        if (btn.disabled) return;
        const originalText = btn.textContent.trim();
        btn.disabled = true;
        btn.textContent = 'Adding…';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
          });

          if (!res.ok) throw new Error('Cart error');
          const data = await res.json();

          // Apply discount code if present
          const coupon = btn.dataset.coupon;
          if (coupon) await applyDiscountCode(coupon);

          btn.textContent = 'Added!';

          // 更新右上角购物车数量
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const count = cart.item_count;
          let bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (count > 0) {
            if (!bubble) {
              const iconEl = document.querySelector('#cart-icon-bubble');
              if (iconEl) {
                iconEl.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true"></span></div>');
                bubble = iconEl.querySelector('.cart-count-bubble');
              }
            }
            if (bubble) {
              const countSpan = bubble.querySelector('span[aria-hidden]');
              if (countSpan) countSpan.textContent = count > 99 ? '99+' : count;
              bubble.style.display = '';
            }
          } else if (bubble) {
            bubble.style.display = 'none';
          }

          // 触发事件并尝试打开 cart drawer
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          const cartDrawer = document.querySelector('cart-drawer, cart-notification');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } catch (err) {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
        }
      });
    });
  }

  // ── Render one embed element ─────────────────────────────────
  async function renderEmbed(el) {
    const raw = el.dataset.inlineProducts || '';
    const handles = raw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (handles.length === 0) return;

    const heading = el.dataset.heading   || '';
    const columns = parseInt(el.dataset.columns || '3', 10);
    const viewAllUrl   = el.dataset.viewAllUrl   || '';
    const viewAllLabel = el.dataset.viewAllLabel || 'Shop all';

    el.classList.add('ip-embed', 'ip-embed--cols-' + columns);
    el.innerHTML = '<div class="ip-embed__skeleton"></div>';

    const results = await Promise.all(
      handles.map(function (handle) {
        return fetchProduct(handle).catch(function (err) {
          console.warn('[inline-product-embed] Error fetching product:', handle, err);
            return null;
          });
      })
    );

    const products = results.filter(Boolean);

    if (products.length === 0) {
      el.innerHTML = '';
      return;
    }

    const headingHtml = heading
      ? '<h2 class="ip-embed__heading">' + escapeHtml(heading) + '</h2>'
      : '';

    const viewAllHtml = viewAllUrl
      ? '<a href="' + viewAllUrl + '" class="ip-embed__view-all">' + escapeHtml(viewAllLabel) + '</a>'
      : '';

    const headerHtml = (headingHtml || viewAllHtml)
      ? '<div class="ip-embed__header">' + headingHtml + viewAllHtml + '</div>'
      : '';

    const cardsHtml = products.map(function (p) {
      return '<div class="ip-embed__item">' + buildCard(p) + '</div>';
    }).join('');

    el.innerHTML = headerHtml + '<div class="ip-embed__grid">' + cardsHtml + '</div>';

    bindAddToCart(el);
  }

  // ── Init: find all embeds on page ────────────────────────────
  function init() {
    document.querySelectorAll('[data-inline-products]').forEach(renderEmbed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
